import { map1091ToBasicInfo } from 'legacy/lut/services/partner360/basicInfo/mappings/map1091ToBasicInfo'

import { Logic, Operator } from 'core-components/types'

import { getJBPBasicInfoCrud } from './helpers/getJBPBasicInfoCrud'
import { IJBPBasicInfoCrudParams } from './models'

export const fetchPartnerBasicInfo = async (params: IJBPBasicInfoCrudParams) => {
  const crud = getJBPBasicInfoCrud()

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: params.partnerId,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: params.fYear,
      },
      {
        logic: Logic.OR,
        filters: [
          {
            field: 'ProgramType',
            operator: Operator.EQUAL,
            value: params.programType,
          },
          {
            field: 'ProgramType',
            operator: Operator.ISNULL,
            value: '',
          },
        ],
      },
    ],
  })

  crud.setSort({
    field: 'EntryId',
    dir: 'desc',
  })

  const response = await crud.fetch()
  return response.items.map(map1091ToBasicInfo)
}
